import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class FormDateMaxError extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.field_name}>
                {field =>
                    <FormattedMessage id="CMS.Form.Date.max" values={{ field: field, max: this.props.max }}>
                        {message => <p>{message}</p>}
                    </FormattedMessage>
                }
            </FormattedMessage>
        );
    }
}

FormDateMaxError.propTypes = {
    field_name: PropTypes.string.isRequired
};
export default FormDateMaxError